import { useEffect, useState } from "react"

import { appStore } from "../store/AppStore"

export const useTransitions = (value = "transform 0.2s ease-in-out") => {
  const [transitions, setTransitions] = useState(value)
  const accessibility = appStore((state) => state.accessibility)
  useEffect(() => {
    setTransitions(
      accessibility.transitions ? "transform 0.2s ease-in-out" : "none",
    )
  }, [accessibility.transitions])
  return transitions
}
